"use client";

import { SessionProvider } from "next-auth/react";
import "./globals.css";
import QueryProvider from "@/components/providers/query-provider";
import { ThemeProvider } from "@/components/providers/theme-provider";
import { PostHogProvider } from "@/components/providers/posthog-provider";

interface RootProviderProps {
  children: React.ReactNode;
  session?: any;
}

export const RootProvider = ({ children, session }: RootProviderProps) => {
  return (
    <PostHogProvider>
      <SessionProvider session={session}>
        <QueryProvider>
          <ThemeProvider
            attribute="class"
            defaultTheme="dark"
            enableColorScheme
            enableSystem
            disableTransitionOnChange
          >
            {children}
          </ThemeProvider>
        </QueryProvider>
      </SessionProvider>
    </PostHogProvider>
  );
};
